<div class="flex flex-col bg-white comic-book">
  <article>
    <!-- Title Header Section -->
    <div
      class="title-header pt-12 flex flex-wrap min-h-screen items-center justify-center background-blue relative border-4 border-black border-t-0 mb-8"
    >
      <span
        class="absolute w-1/4 right-0 top-0 h-full halftone top-right"
      ></span>
      <span
        class="absolute w-1/4 left-0 bottom-0 h-full halftone bottom-left"
      ></span>

      <div class="w-full straighten p-8 text-center">
        <h1 class="text-container">
          <span
            class="text text-flat font-bangers text-6xl md:text-8xl pr-2 bg-gradient-to-r from-purple-950 via-purple-700 to-purple-900"
          >
            Mother Tongue Education
          </span>
        </h1>
        <h2
          class="text-5xl font-semibold tracking-tight select-none mb-4 text-purple-50"
        >
          Why It Matters and How Study Heroes is Making a Difference
        </h2>
      </div>
    </div>

    <!-- Introduction Section -->
    <section
      class="rotate flex flex-wrap min-h-screen items-center justify-center background-teal-lime relative border-4 border-black mt-8"
    >
      <span
        class="absolute w-1/4 right-0 top-0 h-full halftone top-right"
      ></span>
      <span
        class="absolute w-1/4 left-0 bottom-0 h-full halftone bottom-left"
      ></span>

      <div class="straighten w-full lg:w-1/2 p-8">
        <h2 class="text-container">
          <span
            class="text text-flat font-bangers text-7xl pr-2 bg-gradient-to-r from-green-600 to-green-400"
          >
            Introduction
          </span>
        </h2>
        <p class="mt-6 text-2xl text-green-50">
          Education shapes the future, and the language it's delivered in can
          make all the difference. Mother tongue education teaching children in
          their native language has proven to be a powerful tool for learning.
          Yet, making it a reality for everyone isn't easy. This article dives
          into why mother tongue education is so valuable and how "Education
          Study Heroes" is tackling the obstacles by bringing together teachers,
          students, content creators, and programmers to build amazing
          educational content in every language, using resources that already
          exist.
        </p>
      </div>
      <div class="straighten w-full lg:w-1/2 p-8"></div>
    </section>

    <!-- Benefits Section -->
    <section
      class="rotate flex flex-wrap min-h-screen items-center justify-center background-pink relative border-4 border-black mt-8"
    >
      <span class="absolute w-1/3 left-0 h-full halftone bottom-left"></span>
      <span
        class="absolute w-1/3 right-0 top-0 h-full halftone top-right"
      ></span>

      <div class="straighten w-full lg:w-1/2 p-8">
        <h2 class="text-container">
          <span
            class="text text-flat font-bangers text-7xl pr-2 bg-gradient-to-r from-purple-900 to-purple-700"
          >
            Why Mother Tongue Education is a Good Thing
          </span>
        </h2>
        <p class="mt-6 text-2xl text-pink-50">
          Teaching kids in their first language isn't just a nice idea it's
          backed by real benefits, and sets kids up for success while keeping
          their roots strong.
        </p>
      </div>
      <div class="straighten w-full lg:w-1/2 p-8">
        <ul class="mt-4 space-y-4 text-xl text-pink-50">
          <li class="flex items-start">
            <span
              class="inline-block w-8 h-8 bg-purple-900 rounded-full mr-3 flex-shrink-0 mt-1"
            ></span>
            <div>
              <strong class="text-2xl">It Boosts Brainpower:</strong> When kids
              learn in a language they already know, they understand concepts
              faster and remember them better. It's like building a house on a
              solid foundation everything just clicks.
            </div>
          </li>
          <li class="flex items-start">
            <span
              class="inline-block w-8 h-8 bg-purple-900 rounded-full mr-3 flex-shrink-0 mt-1"
            ></span>
            <div>
              <strong class="text-2xl">It Keeps Cultures Alive:</strong> Using
              local languages in schools helps protect them from disappearing.
              It's a way to honor traditions and give students pride in who they
              are.
            </div>
          </li>
          <li class="flex items-start">
            <span
              class="inline-block w-8 h-8 bg-purple-900 rounded-full mr-3 flex-shrink-0 mt-1"
            ></span>
            <div>
              <strong class="text-2xl">It Improves School Results:</strong>
              Research, like reports from UNESCO, shows that students in mother
              tongue programs often read and learn better than those forced into
              unfamiliar languages.
            </div>
          </li>
          <li class="flex items-start">
            <span
              class="inline-block w-8 h-8 bg-purple-900 rounded-full mr-3 flex-shrink-0 mt-1"
            ></span>
            <div>
              <strong class="text-2xl">It Feels Good:</strong> Learning in a
              language you speak at home builds confidence. Kids feel seen,
              heard, and ready to take on the world.
            </div>
          </li>
        </ul>
      </div>
    </section>

    <!-- Problems Section -->
    <section
      class="rotate flex flex-wrap min-h-screen items-center justify-center background-blue relative border-4 border-black mt-8"
    >
      <span
        class="absolute w-1/4 right-0 top-0 h-full halftone top-right"
      ></span>
      <span
        class="absolute w-1/4 left-0 bottom-0 h-full halftone bottom-left"
      ></span>

      <div class="straighten w-full lg:w-1/2 p-8">
        <h2 class="text-container">
          <span
            class="text text-flat font-bangers text-7xl pr-2 bg-gradient-to-r from-red-700 to-red-400"
          >
            The Problems Holding It Back
          </span>
        </h2>
        <p class="mt-6 text-2xl text-blue-50">
          So, if it's so great, why isn't every school doing it? Here are the
          big roadblocks:
        </p>

        <p class="mt-6 text-2xl text-blue-50">
          These issues mean millions of kids miss out on learning in a way that
          works best for them.
        </p>
      </div>
      <div class="straighten w-full lg:w-1/2 p-8">
        <ul class="mt-4 space-y-4 text-xl text-blue-50">
          <li class="flex items-start">
            <span
              class="inline-block w-8 h-8 bg-red-500 rounded-full mr-3 flex-shrink-0 mt-1"
            ></span>
            <div>
              <strong class="text-2xl">Not Enough Stuff:</strong> Many languages
              don't have enough textbooks, worksheets, or even teachers who can
              teach in them.
            </div>
          </li>
          <li class="flex items-start">
            <span
              class="inline-block w-8 h-8 bg-red-500 rounded-full mr-3 flex-shrink-0 mt-1"
            ></span>
            <div>
              <strong class="text-2xl">Language Mix-Ups:</strong> Dialects can
              differ a lot, and there's often no standard way to teach in some
              languages, which makes things messy.
            </div>
          </li>
          <li class="flex items-start">
            <span
              class="inline-block w-8 h-8 bg-red-500 rounded-full mr-3 flex-shrink-0 mt-1"
            ></span>
            <div>
              <strong class="text-2xl">No Support:</strong> Governments might
              not have the money or the will to push for mother tongue programs.
            </div>
          </li>
        </ul>
      </div>
    </section>

    <!-- Solutions Section -->
    <section
      class="rotate flex flex-wrap min-h-screen items-center justify-center background-deep-purple-pink relative border-4 border-black mt-8"
    >
      <span class="absolute w-1/3 left-0 h-full halftone bottom-left"></span>
      <span
        class="absolute w-1/3 right-0 top-0 h-full halftone top-right"
      ></span>

      <div class="straighten w-full lg:w-1/2 p-8">
        <h2 class="text-container">
          <span
            class="text text-flat font-bangers text-7xl pr-2 bg-gradient-to-r from-purple-400 to-purple-900"
          >
            How Study Heroes Steps In
          </span>
        </h2>
        <p class="mt-6 text-2xl text-pink-50">
          Study Heroes is a platform with a mission to fix these problems by
          connecting people, existing resources and creation tools. Study Heroes
          is turning mother tongue education from a dream into a reality, one
          language at a time.
        </p>
      </div>
      <div class="straighten w-full lg:w-1/2 p-8">
        <ul class="mt-4 space-y-4 text-xl text-pink-50">
          <li class="flex items-start">
            <span
              class="inline-block w-8 h-8 bg-purple-900 rounded-full mr-3 flex-shrink-0 mt-1"
            ></span>
            <div>
              <strong class="text-2xl">Teamwork Makes the Dream Work:</strong>
              Teachers bring classroom know-how, students share what they need,
              parents provide valuable feedback, content creators craft lessons,
              sponsors help fund development, and programmers build the tech to
              make it all happen. Together, they're unstoppable.
            </div>
          </li>
          <li class="flex items-start">
            <span
              class="inline-block w-8 h-8 bg-purple-900 rounded-full mr-3 flex-shrink-0 mt-1"
            ></span>
            <div>
              <strong class="text-2xl">Sharing is Caring:</strong> The platform
              lets users create and share top-notch materials in tons of
              languages, so no one has to start from scratch.
            </div>
          </li>
          <li class="flex items-start">
            <span
              class="inline-block w-8 h-8 bg-purple-900 rounded-full mr-3 flex-shrink-0 mt-1"
            ></span>
            <div>
              <strong class="text-2xl">Building on What's There:</strong>
              Instead of reinventing the wheel, Study Heroes takes existing
              resources like books or online lessons and adapts them to fit
              different languages and communities.
            </div>
          </li>
          <li class="flex items-start">
            <span
              class="inline-block w-8 h-8 bg-purple-900 rounded-full mr-3 flex-shrink-0 mt-1"
            ></span>
            <div>
              <strong class="text-2xl">Powered by People:</strong> It's not just
              a tool; it's a community. Local talent help shape the content,
              making sure content is relavant and easy to understand.
            </div>
          </li>
        </ul>
      </div>
    </section>

    <!-- Conclusion Section -->
    <section
      class="rotate flex flex-wrap min-h-screen items-center justify-center background-green relative border-4 border-black mt-8 mb-16"
    >
      <span
        class="absolute w-1/4 right-0 top-0 h-full halftone top-right"
      ></span>
      <span
        class="absolute w-1/4 left-0 bottom-0 h-full halftone bottom-left ht-dark"
      ></span>

      <div class="straighten w-full lg:w-1/2 p-8">
        <h2 class="text-container">
          <span
            class="text text-flat font-bangers text-7xl pr-2 bg-gradient-to-r from-green-600 to-green-400"
          >
            Wrapping It Up
          </span>
        </h2>
        <p class="mt-6 text-2xl text-green-50">
          Mother tongue education isn't just smart it's essential. It helps kids
          learn better, keeps cultures thriving, and builds a brighter future.
          Sure, there are hurdles, but Study Heroes is proving they're not
          impossible to jump. By letting teachers, students, content creators,
          and programmers work together and build on what's already out there,
          this platform is creating a world where every child can learn in their
          own language.
        </p>

        <div class="mt-10 text-center">
          <a
            href="/get-involved"
            class="btn-comic-outline bg-green-700 hover:bg-green-600"
          >
            Join the Heroes and Make a Difference!
          </a>
        </div>
      </div>
      <div class="straighten w-full lg:w-1/2 p-8">
        <div class="flex flex-col justify-center gap-4 max-w-xl mx-auto">
          <h3 class="text-3xl font-bangers mb-4">Learn More</h3>
          <a
            href="https://www.unicef.org/india/stories/why-mother-tongue-education-holds-key-unlocking-every-childs-potential"
            class="btn btn-primary"
            target="_blank"
          >
            UNICEF: Mother Tongue Education
          </a>
          <a
            href="https://teachenglishtoday.org/index.php/2010/06/mother-tongue-education-in-south-africa-2/"
            class="btn btn-primary"
            target="_blank"
          >
            Mother Tongue Education in South Africa
          </a>
        </div>
      </div>
    </section>
  </article>
</div>
